import React from 'react';

import { Icon } from '@chakra-ui/react';

export const SnoozeIcon = props => (
  <Icon viewBox="0 0 24 24" color="inherit" h="full" w="full" {...props}>
    <path d="M10,21h4a2,2,0,0,1-4,0ZM20,9H18.414l2.293-2.293A1,1,0,0,0,20,5H16a1,1,0,0,0,0,2h1.586L15.293,9.293A1,1,0,0,0,16,11h4a1,1,0,0,0,0-2Zm.707,8.293L19,15.586V13H17v3a1,1,0,0,0,.293.707l.293.293H6.414l.293-.293A1,1,0,0,0,7,16V10a4.98,4.98,0,0,1,5.912-4.912L14.5,3.5a.913.913,0,0,0-.168-.1A7,7,0,0,0,13,3.084V2a1,1,0,0,0-2,0V3.08A7,7,0,0,0,5,10v5.586L3.293,17.293A1,1,0,0,0,4,19H20a1,1,0,0,0,.707-1.707Z" />
  </Icon>
);
